import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Quote } from "lucide-react";
import { WORKSHOPS } from "./workshops";

export default function WorkshopModal({ workshopId, open, onOpenChange }) {
  if (!workshopId) return null;
  const w = WORKSHOPS[workshopId];
  if (!w) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-3xl max-h-[88vh] overflow-y-auto p-0 border-0"
        style={{ background: "#fbf6f3" }}
        data-testid={`workshop-modal-${workshopId}`}
      >
        {/* Header band */}
        <div className="px-7 sm:px-12 pt-10 pb-7 text-center" style={{ background: "#d9c08a" }}>
          <p className="text-xs uppercase tracking-[0.3em] font-semibold" style={{ color: "#5b223f" }}>
            Workshop
          </p>
          <DialogHeader>
            <DialogTitle className="font-display text-3xl sm:text-4xl mt-2" style={{ color: "#5b223f" }}>
              {w.title}
            </DialogTitle>
            <DialogDescription className="font-display italic text-lg mt-1" style={{ color: "#5b223f" }}>
              {w.subtitle}
            </DialogDescription>
          </DialogHeader>
        </div>

        {/* Epigraph */}
        <div className="px-7 sm:px-12 pt-7 pb-2 text-center">
          <Quote className="w-6 h-6 mx-auto mb-2" style={{ color: "#cca300" }} />
          <p className="font-display italic text-xl sm:text-2xl" style={{ color: "#5b223f" }}>
            "{w.epigraph}"
          </p>
          {w.epigraphFooter && (
            <p className="mt-2 text-sm sm:text-base text-wine/80 max-w-xl mx-auto leading-relaxed">
              {w.epigraphFooter}
            </p>
          )}
        </div>

        {/* Sections */}
        <div className="px-7 sm:px-12 py-8 space-y-7">
          {w.sections.map((s, i) => (
            <div key={i}>
              <h3 className="font-display text-2xl mb-3" style={{ color: "#9c3a50" }}>{s.heading}</h3>
              {s.body && <p className="text-[1rem] leading-[1.85]" style={{ color: "#5b3a4a" }}>{s.body}</p>}
              {s.bullets && (
                <ul className="mt-3 space-y-2.5">
                  {s.bullets.map((b, j) => (
                    <li key={j} className="flex gap-3 items-start text-[0.97rem] leading-relaxed" style={{ color: "#5b3a4a" }}>
                      <span className="mt-2 inline-block w-1.5 h-1.5 rounded-full bg-[var(--lh-gold)] flex-shrink-0" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              )}
              {s.bodyAfter && <p className="text-[1rem] leading-[1.85] mt-3" style={{ color: "#5b3a4a" }}>{s.bodyAfter}</p>}
            </div>
          ))}
        </div>

        {/* Contact footer */}
        <div className="px-7 sm:px-12 py-7 text-center border-t border-[var(--lh-gold)]/30" style={{ background: "#f1e3e0" }}>
          <p className="text-sm uppercase tracking-[0.24em] font-semibold" style={{ color: "#5b223f" }}>
            Verna Carr · vernacarrspiritualhealing.com · 027 320 0079
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
